<template>
  <div class="add-tables-to-view">
    <a class="is-pulled-right rack-btn" @click="open_popup()" v-tooltip="{ content: localization('app-insert-racks', 'Insert Racks') }">
      <img src="@/assets/icons/rack.svg" alt />
    </a>
    <div class="add-tables-to-view__button-box ">
      <!-- <p class="hover-text heading-secondary">INSERT RACKS IN VIEW</p> -->
    </div>
    <b-modal class="racks-popup" :active.sync="add_tables_popup">
      <div class="card" style="border-radius:10px">
        <div class="card-header" style="box-shadow:none;">
          <span class="card-header-title is-pulled-left" v-if="lang_data">{{ localization("app-insert-racks-in-view", "Inser Racks in View") }}</span>
          <img class="is-pointer" @click="add_tables_popup = false" src="@/assets/icons/close.svg" alt />
        </div>
        <div class="card-content add-tables-to-view__card-content">
          <img src="@/assets/icons/rack-icon.svg" alt />
          <section v-if="selected_features && selected_features.length">
            <b-field>
              <b-autocomplete
                class="is-shadowless is-fullwidth"
                v-model="name"
                @input="fetch_search_results"
                ref="autocomplete"
                :data="search_data"
                placeholder="e.g. North West region"
                @select="(option) => (selected = option)"
                field="name"
              >
                <template slot-scope="props">{{ props.option.name }}</template>
                <template slot="empty">No results for {{ name }}</template>
              </b-autocomplete>
            </b-field>
          </section>

          <section style="margin-top:1rem;" v-else class="has-text-centered">{{localization("app-no-racks-selected","No racks selected")}}</section>
          <div class="has-text-centered has-text-danger" v-if="error">{{ error }}</div>
          <div class="has-text-centered has-text-success" v-if="success">{{ success }}</div>
        </div>
        <div class="save-racks">
          <a
            href="#"
            :disabled="!(selected_features && selected_features.length) || !name"
            class="button btn-save is-info is-semibold-16-600-19"
            @click="save()"
            v-if="lang_data"
            >{{ localization("app-save", "Save") }}</a
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import ApiService from "../../api.service";
  const apiService = new ApiService();

  export default {
    data() {
      return {
        add_tables_popup: false,
        data: [],
        name: "",
        error: "",
        success: "",
        selected: null,
        is_loading: false,
      };
    },
    computed: {
      ...mapState(["token", "api_host", "selected_features"]),
      search_data() {
        return this.data;
      },
    },
    methods: {
      open_popup() {
        this.success = "";
        this.name = "";
        this.error = "";
        this.add_tables_popup = true;
      },
      async fetch_search_results() {
        let results = await apiService.get(`${this.api_host}/views/?q=${this.name}`);
        this.data = results.data;
      },
      save() {
        if (!this.selected) {
          this.error = "First select view to insert racks!";
          return;
        }
        let data = { tableUids: [] };
        this.selected_features.forEach((f) => {
          if (f.properties.class_name === "table") data.tableUids.push(f.properties.uid);
        });

        apiService.post(`${this.api_host}/views/view/${this.selected.uid}/insert/tables`, data).then(
          (results) => {
            this.success = results.data.message;
            setTimeout(() => {
              this.add_tables_popup = false;
            }, 1000);
          },
          (errors) => {
            this.error = errors.response.data.message;
          }
        );
      },
    },
  };
</script>
<style lang="scss">
  .rack-btn {
    position: fixed;
    right: 8rem;
    top: 1.1rem;
    transform: rotate(-90deg);
    z-index: 38;
    // border-bottom: 1px solid #eee;
  }
  .add-tables-to-view {
    position: fixed;
    right: 8rem;
    top: 1.1rem;
    // transform: rotate(-90deg);
    z-index: 38;
    &__button-box {
      // padding-right: 1rem;
      // display: flex;
      // justify-content: flex-end;
      // align-items: center;
      .hover-text {
        display: none;
        margin-bottom: 0;
        margin-right: 0.7rem;
      }
      &:hover .hover-text {
        display: block;
      }
    }
    &__card-content {
      min-height: 11rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 0;
    }
    .modal-content {
      width: 25rem;
    }
    .input:active,
    .input:focus {
      border-color: #b5b5b5;
      box-shadow: none;
    }
    .racks-popup {
      .card-header {
        img {
          padding: 0 1.2rem;
        }
        .card-header-title {
          font-family: Barlow-medium;
          font-size: 18px;
          font-weight: 500;
          color: #171e48;
          padding: 1rem;
        }
      }
      .autocomplete .control input {
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #e7e7e7;
      }
      .autocomplete .control .input {
        border-radius: 0;
        text-align: center;
      }
      .save-racks {
        border: none;
        display: flex;
        justify-content: center;
        .btn-save {
          margin: 0.75rem auto 2.5rem auto;
          width: 240px;
          height: 50px;
          border-radius: 6px;
          background-color: #5c7ef7;
        }
      }
    }
  }
</style>
